import Loadable from 'react-loadable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Loader } from '@/components';
import authActions from '@/redux/auth/actions';

const AsyncPasswordReset = Loadable({
  loader: () => import('./PasswordReset'),
  loading: Loader,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      resetPassword: authActions.resetPassword,
      sendEmailReset: authActions.sendEmailReset,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(AsyncPasswordReset);
